import Box from "@mui/material/Box";
import {RecommendationsInformationElement} from "./RecommendationsInformationElement";
import {RecommendationsSuccessElement} from "./RecommendationsSuccessElement";
import {RecommendationsWarningElement} from "./RecommendationsWarningElement";

interface Props {
    warningMessages?: Record<string, string>[];
    informationMessages?: Record<string, string>[];
    successMessages?: Record<string, string>[];
    locale: string;
    printMode?: boolean;
}

export function RecommendationsElement({
    warningMessages,
    informationMessages,
    successMessages,
    locale,
    printMode = false,
}: Props) {
    const hasRecommendations = Boolean(
        warningMessages?.length
        || informationMessages?.length
        || successMessages?.length
    );
    if (!hasRecommendations) return null;

    return (
        <Box sx={{display: "flex", flexDirection: "column", gap: 0.5, py: 0.5}}>
            <RecommendationsWarningElement
                messages={warningMessages}
                locale={locale}
                printMode={printMode}
            />
            <RecommendationsInformationElement
                messages={informationMessages}
                locale={locale}
                printMode={printMode}
            />
            <RecommendationsSuccessElement
                messages={successMessages}
                locale={locale}
                printMode={printMode}
            />
        </Box>
    );
}
